import graphql__7ae4e015477e0d8d1add from "./__generated__/MarketingViewQuery.graphql.ts";import * as React from "react";
import {connect, ConnectedProps} from "react-redux";
import {Outlet} from "react-router";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import {useIntl} from "react-intl";
import type {MarketingViewQuery as MarketingViewQueryType} from "./__generated__/MarketingViewQuery.graphql";
import MarketingViewQuery from "./__generated__/MarketingViewQuery.graphql";
import MarketingEmailsQuery from "./__generated__/MarketingEmailsViewQuery.graphql";
import MailingListsQuery from "./__generated__/MailingListsViewMailingListsQuery.graphql";
import EmailTemplatesQuery from "./__generated__/EmailTemplatesViewEmailTemplatesQuery.graphql";
import EmailLayoutsQuery from "./__generated__/EmailLayoutsViewEmailLayoutsQuery.graphql";

type MarketingViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type MarketingViewProps = MarketingViewParams & ConnectedProps<typeof connector>;

const MarketingView: React.FC<MarketingViewProps> = (props) => {
    const intl = useIntl();

    usePreloadedQuery<MarketingViewQueryType>(
        graphql__7ae4e015477e0d8d1add,
        props.prepared.marketingViewQuery,
    );

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.marketing'}), to: '/marketing'},
    ]

    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.marketing.emails'}),
            to: '/marketing/emails',
        },
        {
            label: intl.formatMessage({id: 'tab.marketing.lists'}),
            to: '/marketing/lists'
        },
        {
            label: intl.formatMessage({id: 'tab.marketing.templates'}),
            to: '/marketing/templates'
        },
        {
            label: intl.formatMessage({id: 'tab.marketing.layouts'}),
            to: '/marketing/layouts'
        },
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <div className="py-4 md:flex md:items-center md:justify-between">
                <div className="flex-1 min-w-0">
                    <div className="mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                        <div className="flex items-center space-x-5">
                            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{intl.formatMessage({id: 'view.marketing.headline'})}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="lg:mt-6 mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={props.prepared}/>
            </div>
        </>
    );
}

export default connector(MarketingView);

function prepare_MarketingView(params, relayEnvironment) {
    return {
        marketingViewQuery: loadQuery(
            relayEnvironment,
            MarketingViewQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        marketingEmailsQuery: loadQuery(
            relayEnvironment,
            MarketingEmailsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        mailingListsQuery: loadQuery(
            relayEnvironment,
            MailingListsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        emailTemplatesQuery: loadQuery(
            relayEnvironment,
            EmailTemplatesQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
        emailLayoutsQuery: loadQuery(
            relayEnvironment,
            EmailLayoutsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_MarketingView};
